import React from 'react';

const BlockEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const blockingPlayerId = event.details?.blockingPlayerId;
    const blockingPlayerName = getPlayerName(blockingPlayerId);
    const blockingPlayerMugshotUrl = blockingPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${blockingPlayerId}.png` : null;
    const shootingPlayerId = event.details?.shootingPlayerId;
    const shootingPlayerName = getPlayerName(shootingPlayerId);
    const shootingPlayerMugshotUrl = shootingPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${shootingPlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{blockingPlayerName}</span>
            {blockingPlayerMugshotUrl && (
                <img
                    src={blockingPlayerMugshotUrl}
                    alt={blockingPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 mx-2">Blocked Shot by</span>
            {shootingPlayerMugshotUrl && (
                <img
                    src={shootingPlayerMugshotUrl}
                    alt={shootingPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 ml-2">{shootingPlayerName}</span>
        </div>
    );
};

export default BlockEvent;
